module.exports = __webpack_public_path__ + "img/mobileBanner3.edfe4f9e.png";